import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({
	providedIn: 'root'
})
export class CommonService {

	constructor(
		private _snackBar: MatSnackBar,
		private spinner: NgxSpinnerService
	) { }

	getParameterByName(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	async prcLoading() {
		this.spinner.show();
	}

	async closeLoading() {
		setTimeout(() => {
			this.spinner.hide();
		}, 1500);
	}

	async topToast(message: any) {
		this._snackBar.open(message, '', {
			horizontalPosition: 'center',
			verticalPosition: 'top',
			duration: 5000,
		});
	}

	async midToast(message: any) {
	}

	async bottomToast(message: any) {
		this._snackBar.open(message, "", {
			duration: 1000,
		});
	}

}
